import { Site, SiteKeywordStats } from "../../api/Api";

export interface SiteData {
  id: number;
  url: string;
  fqdn: string;
  domain: string;
  tld: string;
  trd: string | null;
  crawl_interval: string;
  crawl_status: string;
}

export interface SiteStats {
  id: number;
  keywords?: SiteKeywordStats;
  pages: {
    total: number;
    optimized: number;
  };
  recommendations: {
    total: number;
    active: number;
  };
}

export interface ButtonProps {
  icon?: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  onClick?: () => void;
  className?: string;
}

export interface SiteCardProps {
  site: Site;
  stats: SiteStatsWithKeywords;
}

export type SiteStatsWithKeywords = SiteStats & { keywords: SiteKeywordStats };

export function hasKeywords(
  s: SiteStats | undefined,
): s is SiteStatsWithKeywords {
  return !!s?.keywords;
}
